module.exports = __webpack_public_path__ + "static/img/12.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/12.png
// module id = G1ZM
// module chunks = 0